import type { UnknownInputParams } from 'expo-router'

export const getSearchParams = (params?: UnknownInputParams) => {
  const paramsArray =
    params &&
    Object.entries(params).reduce<string[][]>((acc, [key, values]) => {
      if (values === undefined || values === null) return acc
      if (Array.isArray(values)) {
        values.forEach((value) => acc.push([key, value.toString()]))
        return acc
      }
      acc.push([key, values.toString()])
      return acc
    }, [])
  const searchParams = new URLSearchParams(paramsArray)
  return {
    searchParams,
    search: paramsArray && paramsArray.length > 0 ? `?${searchParams.toString()}` : '',
  }
}
